// eslint-disable-next-line import/prefer-default-export
export const EMBEDDED_COMPONENTS = {
  ACCOUNT_MANAGEMENT: 'account-management',
  ACCOUNT_ONBOARDING: 'account-onboarding',
};
